<gbc-page-error-handler [content]="content" [pageError$]="pageError$">
</gbc-page-error-handler>
<ng-template #content>

  @if (route.children.length !== 0) {
    <router-outlet></router-outlet>
  }

  @if (route.children.length === 0) {
    @if (isMixit$ | async) {
      <app-mixit-facility-page></app-mixit-facility-page>
    }
    @if (isBuildingConnect$ | async) {
      <app-buildingconnect-facility-page></app-buildingconnect-facility-page>
    }
    @if (isConnectingCore$ | async) {
      <app-connectingcore-facility-page></app-connectingcore-facility-page>
    }
  }
</ng-template>
